import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Pagination, Button, TemplateTable, NoInformationFound, Loader, ApiErrorModal, Icon, Helper } from 'Components';
import i18n from 'i18next';
import { handlePageNumberChange, handlePageSizeChange } from 'helpers/pagination';
import { urlSearchToObject, cleanSearchParams } from 'helpers/urlSearchParams';
import { buildUrl } from 'helpers/misc';
import Fetch from 'helpers/fetch';
import history from 'src/history';
import DownloadFromUrl from 'helpers/download';
import { copy as deepCopy } from 'helpers/deep';
import { INVOICES } from 'constants/apis';
import InvoicesTemplate from './InvoicesTemplate/InvoicesTemplate';
import invoiceDescription from './invoice-description';
import InvoicesListMobile from './InvoicesListMobile/InvoicesListMobile';
import InvoicesDesktopSearchHeader from './InvoicesListHeader/InvoicesDesktopSearchHeader/InvoicesDesktopSearchHeader';
import InvoicesDesktopHeader from './InvoicesListHeader/InvoicesDesktopHeader/InvoicesDesktopHeader';
import './InvoicesList.css';

class InvoicesList extends Component {
  constructor(props) {
    super(props);

    const searchValues = {
      'Balance Due': { paid: 'NO' },
      Paid: { paid: 'YES' },
      'All Invoices': {},
    };

    const tabs = Object.keys(searchValues);

    this.state = {
      menuRow: null,
      tabs,
      searchValues,
      hasMixedCurrency: false,
    };

    this.handleTabClick = this.handleTabClick.bind(this);
    this.handleTrExpand = this.handleTrExpand.bind(this);
    this.handleMoreVertClick = this.handleMoreVertClick.bind(this);

    this.handlePageSizeChange = handlePageSizeChange('invoices').bind(this);
    this.handlePageNumberChange = handlePageNumberChange('invoices').bind(this);

    this.handleMenuClick = this.handleMenuClick.bind(this);
    this.handleCheckClick = this.handleCheckClick.bind(this);
    this.handlePaySelectedInvoicesClick = this.handlePaySelectedInvoicesClick.bind(this);
    this.handleExportInvoices = this.handleExportInvoices.bind(this);
    this.handleSearchDownload = this.handleSearchDownload.bind(this);
  }

  handleTabClick(tabIndex) {
    const { searchValues, tabs } = this.state;
    const searchParams = searchValues[tabs[tabIndex]];
    const invoices = Object.assign({}, this.props.data, {
      searchParams,
      tabIndex,
      pageNumber: 1,
      shouldLoad: this.props.data.tabIndex !== tabIndex,
    });

    this.props.setAppState({ invoices });
  }

  handleTrExpand(e, index) {
    e.stopPropagation();
    const abortController = new AbortController();
    const invoices = { ...deepCopy(this.props.data), abortController };
    invoices.data[index].Expanded = !invoices.data[index].Expanded;
    if(invoices.data[index].Jobs == null || invoices.data[index].Jobs.length === 0){
      const params = {
        maxxamJobNumber: this.props.data.data[index].MaxxamJobNumber,
        prefixInvoiceNumber: this.props.data.data[index].PrefixInvoiceNumber,
      };
  
      const url = buildUrl(`${INVOICES}/Jobs`, params);
      Fetch.Get(url)
        .then(response => response.json())
        .then((data) => {
          invoices.data[index].Jobs = data.DataList;
          this.props.setAppState({ invoices });
        })
        .catch(err => log.error(err));
    }else{
      this.props.setAppState({ invoices });
    }
    
  }

  handleMoreVertClick(e, index) {
    if ((e.target.tagName === 'SPAN' || e.target.tagName === 'I') && e.target.textContent !== 'more_vert') return;
    const val = this.state.menuRow === index ? null : index;
    this.setState({ menuRow: val });
  }

  handleMenuClick(code, tableIndex) {
    if (code === 'pay') {
      this.props.setAppState(
        (prevState) => ({
          invoices: {
            ...prevState.invoices,
            paySingleInvoice: true,
            singlePayInvoiceNumber: this.props.data.data[tableIndex].InvoiceNumber,
          },
        }),
        () => history.push('/invoices/payment-summary'),
      );
    }

    if (code === 'view') {
      let url = `${INVOICES}/${this.props.data.data[tableIndex].InvoiceNumber}/DownloadInvoice?`;
      if (this.props.IsInternalUser) url = url.concat(`clientNumber=${this.props.clientNumber}`);
      DownloadFromUrl(url).catch(({ response }) => this.props.onAPIError(response, true));
    }
    this.setState({ menuRow: null });
  }

  handleCheckClick(e, tableIndex) {
    e.stopPropagation();
    const invoices = Object.assign({}, this.props.data);
    this.props.saveInvoiceNumbers({
      InvoiceNumber: invoices.data[tableIndex].InvoiceNumber,
      Currency: invoices.data[tableIndex].Currency,
    });
  }

  handlePaySelectedInvoicesClick() {
    const selectedInvoicesCurrency = this.props.data.selectedInvoices.map((item) => item.Currency);
    const isSameCurrency = selectedInvoicesCurrency.every((item) => item === selectedInvoicesCurrency[0]);

    if (isSameCurrency) {
      this.props.history.push('/invoices/payment-summary');
    } else {
      this.setState({
        hasMixedCurrency: true,
      });
    }
  }

  handleExportInvoices() {
    const { searchValues, tabs } = this.state;
    const tab = searchValues[tabs[this.props.data.tabIndex]].paid;
    let url = `${INVOICES}/exportinvoicestoexcel?paid=${tab !== undefined ? tab : ''}`;
    if (this.props.IsInternalUser) url = url.concat(`&clientNumber=${this.props.clientNumber}`);
    DownloadFromUrl(url).catch(({ response }) => this.props.onAPIError(response, true));
  }

  handleSearchDownload() {
    const { searchType, ...globalSearchParams } = cleanSearchParams(urlSearchToObject(this.props.location.search));

    DownloadFromUrl(buildUrl(`${INVOICES}/exportinvoicestoexcel`, globalSearchParams));
  }

  render() {
    const hasInvoiceSelected = this.props.data.selectedInvoices.length > 0;
    const showNoInformationFound = !this.props.data.isLoading && this.props.data.data.length === 0;

    if (this.props.deviceIndex === 0) {
      return (
        <InvoicesListMobile
          {...this.props.data}
          onMoreVertClick={this.handleMoreVertClick}
          onMenuClick={this.handleMenuClick}
          handleTrExpand={this.handleTrExpand}
          menuRow={this.state.menuRow}
          data={this.props.data}
          onTabClick={this.handleTabClick}
          tabs={this.state.tabs}
          showNoInformationFound={showNoInformationFound}
          invoiceJobs={this.props.invoiceJobs}
          downloadInvoices={this.handleExportInvoices}
          hasAccessToInvoices={this.props.hasAccessToInvoices}
        />
      );
    }

    return (
      <div className="invoices-list">
        <div
          className={` invoices-list__pay-selected ${
            hasInvoiceSelected ? '' : 'invoices-list__pay-selected--disabled'
          }`}
        >
          <Helper text={i18n.t('tutorials:invoices.6')}>
            <Button onClick={this.handlePaySelectedInvoicesClick}>
              {i18n.t('invoices:Pay Selected Invoices')}
              <Icon icon="chevron_right" />
            </Button>
          </Helper>
        </div>

        <div className="invoices-list__content">
          {this.props.isGlobalSearch ? (
            <InvoicesDesktopSearchHeader
              onPageSizeChange={this.handlePageSizeChange}
              pageSize={this.props.data.pageSize}
              showNoInformationFound={showNoInformationFound}
              onSearchDownload={this.handleSearchDownload}
            />
          ) : (
            <InvoicesDesktopHeader
              tabs={this.state.tabs}
              tabIndex={this.props.data.tabIndex}
              onTabsChange={this.handleTabClick}
              pageSize={this.props.data.pageSize}
              onPageSizeChange={this.handlePageSizeChange}
              showNoInformationFound={showNoInformationFound}
              downloadInvoices={this.handleExportInvoices}
            />
          )}

          <div className="invoices-list__content__table">
            {this.props.data.isLoading && <Loader isSolidWhite />}

            {showNoInformationFound && !this.props.isGlobalSearch ? (
              <NoInformationFound
                {...invoiceDescription(
                  this.props.hasAccessToInvoices,
                  this.props.isGlobalSearch,
                  this.state.tabs[this.props.data.tabIndex],
                )}
              />
            ) : (
              !showNoInformationFound && (
                <TemplateTable
                  data={this.props.data.data}
                  keys={this.props.data.keys}
                  keyPairs={this.props.data.keyPairs}
                  sort={this.props.data.sort}
                  code={this.props.data.code}
                  selectedInvoices={this.props.data.selectedInvoices.map((item) => item.InvoiceNumber)}
                  template={InvoicesTemplate}
                  invoiceJobs={this.props.invoiceJobs}
                  setAppState={this.props.setAppState}
                  className="template-table__invoices"
                  showLoader={false}
                  onTrExpand={this.handleTrExpand}
                  menuRow={this.state.menuRow}
                  onMoreVertClick={this.handleMoreVertClick}
                  onMenuClick={this.handleMenuClick}
                  onCheckBoxClick={this.handleCheckClick}
                  viewCode={this.props.data.viewCode}
                  isDraggable
                  onSettingClick={() =>
                    this.props.setAppState({
                      settingTableCode: this.props.data.viewCode,
                    })
                  }
                  leadingColumnCount={2}
                  hasSettings
                />
              )
            )}

            {this.props.isGlobalSearch && showNoInformationFound && (
              <NoInformationFound
                {...invoiceDescription(
                  this.props.hasAccessToInvoices,
                  this.props.isGlobalSearch,
                  this.state.tabs[this.props.data.tabIndex],
                )}
              />
            )}
          </div>

          <div className="invoices-list__content__pagination">
            <Helper text={i18n.t('tutorials:pagination.1')}>
              <Pagination
                onClick={this.handlePageNumberChange}
                currentPage={this.props.data.pageNumber}
                itemsPerPage={this.props.data.pageSize}
                totalItems={this.props.data.totalItems}
              />
            </Helper>
          </div>

          <ApiErrorModal
            hidePageUnavailableDescription
            show={this.state.hasMixedCurrency}
            onCloseClick={() => this.setState({ hasMixedCurrency: false })}
            errorMessage={i18n.t('invoices:MixedCurrency')}
            isCloseable
          />
        </div>
      </div>
    );
  }
}

InvoicesList.propTypes = {
  deviceIndex: PropTypes.number,
  hasAccessToInvoices: PropTypes.bool,
  data: PropTypes.shape({
    shouldLoad: PropTypes.bool,
    data: PropTypes.shape([]),
    keys: PropTypes.shape([]),
    keyPairs: PropTypes.shape({}),
    totalItems: PropTypes.number,
    tabIndex: PropTypes.number,
    selectedInvoices: PropTypes.arrayOf(PropTypes.shape({})),
    isLoading: PropTypes.bool,
    pageSize: PropTypes.number,
    Message: PropTypes.string,
    sort: PropTypes.string,
    code: PropTypes.string,
    viewCode: PropTypes.string,
    pageNumber: PropTypes.number,
    globalSearchParams: PropTypes.shape({}),
  }),
  handleSettingClick: PropTypes.func,
  selectedInvoices: PropTypes.arrayOf(PropTypes.string),
  isGlobalSearch: PropTypes.bool,
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
  setAppState: PropTypes.func,
  setHeadTitle: PropTypes.func,
  filterItemValue: PropTypes.string,
  IsInternalUser: PropTypes.bool,
  clientNumber: PropTypes.string,
  saveInvoiceNumbers: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  invoiceJobs: PropTypes.shape({}),
  onAPIError: PropTypes.func,
};

export default InvoicesList;



// WEBPACK FOOTER //
// ./src/containers/Invoices/InvoicesList/InvoicesList.jsx